__turbopack_context__.v({
  "bgimage": "otyYqa_bgimage",
  "bgimageContainer": "otyYqa_bgimageContainer",
  "container": "otyYqa_container",
  "contentContainer": "otyYqa_contentContainer",
  "copy": "otyYqa_copy",
  "copyContainer": "otyYqa_copyContainer",
  "disabled": "otyYqa_disabled",
  "header": "otyYqa_header",
  "modal": "otyYqa_modal",
  "modalContent": "otyYqa_modalContent",
  "modalCtaClose": "otyYqa_modalCtaClose",
  "modalHeading": "otyYqa_modalHeading",
  "signupForm": "otyYqa_signupForm",
});
